import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonText,
  IonButton,
  IonIcon,
  IonSpinner,
} from '@ionic/react';
import { refreshOutline } from 'ionicons/icons';
import PropTypes from 'prop-types';

const MaintenancePage = ({ onRetry, isRetrying }) => {
  const handleRetry = () => {
    if (onRetry && !isRetrying) {
      onRetry();
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="medium">
          <IonTitle>Maintenance</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" fullscreen>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <IonText color="medium" style={{ textAlign: 'center' }}>
            <h1>Service Temporarily Unavailable</h1>
            <p>We are performing scheduled maintenance and the app is temporarily unavailable.</p>
            <p>Please try again in a few minutes.</p>
          </IonText>
          <IonButton
            expand="block"
            onClick={handleRetry}
            style={{ marginTop: '30px', maxWidth: '300px' }}
            color="medium"
            disabled={isRetrying}
          >
            {isRetrying ? (
              <IonSpinner name="dots" />
            ) : (
              <>
                <IonIcon icon={refreshOutline} slot="start" />
                Retry Check
              </>
            )}
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

MaintenancePage.propTypes = {
  onRetry: PropTypes.func.isRequired,
  isRetrying: PropTypes.bool.isRequired,
};

export default MaintenancePage;
